import { PaletteOptions } from '@mui/material/styles/createPalette';
import { grey } from '@mui/material/colors';

export default <PaletteOptions>{
  background: {
    default: grey[50],
  },
};
